import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Address } from 'src/app/core';
import { AddressService } from 'src/app/feature/payment/services/address.service';
import { AreYouSureComponent } from '../../../dialog/are-you-sure/are-you-sure.component';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss'],
})
export class AddressComponent implements OnInit, OnChanges {
  @Input('address') address!: Address;
  @Input('isSelected') isSelected: boolean = false;
  @Output() onDelete = new EventEmitter();

  @ViewChild(MatCheckbox) matCheckBox?: MatCheckbox;

  ngOnInit(): void {}
  constructor(
    protected addressService: AddressService,
    private dialog: MatDialog,
    private snackbar?: MatSnackBar
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('isSelected' in changes) {
      setTimeout(() => {
        if (this.matCheckBox) {
          this.matCheckBox.checked = changes['isSelected'] as any as boolean;
        }
      }, 100);
    }
  }

  edit() {
    this.addressService.openAddressEditDialogBox(this.address);
  }

  delete() {
    this.dialog
      .open(AreYouSureComponent)
      .afterClosed()
      .subscribe({
        next: (result: boolean | undefined): void => {
          if (!!result) {
            this.addressService.deleteAddress(this.address.id).subscribe({
              next: (addressDeleted?: Address) => {
                this.snackbar?.open('با موفقیت حذف شد', '', { duration: 1000 });
                this.onDelete.emit();
              },
              error: (err) => {
                console.error(err);
              },
            });
          }
        },
      });
  }
}
